var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from "react";
import { Button, Grid, Typography, Box, TextField, Select, MenuItem, Autocomplete, Chip, IconButton, } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import OpenDisputeComponent from "./OpenDisputes";
import ClosedDisputesComponent from "./ClosedDisputes";
import { getWeightDiscrepancyDataRequest, getWeightDiscrepancyDataReset } from "@/redux/actions";
import BackDropComponent from "@/components/BackDrop";
import { CLOSED_WEIGHT_OPTION_TYPE, FILTER_ORDER_BY_OPTIONS_WEIGHT } from "@/utils/Constants";
import { getDateString } from "@/utils/Common";
import APIIN from "@/utils/APIIN";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import DisputeFilterDrawer from "./DisputeFilterDrawer";
import _ from "lodash";
import { enqueueSnackbar } from "notistack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const DisputeDiscripancyData = () => {
    const tabs = ["open", "closed"];
    const [activeTab, setActiveTab] = React.useState("1");
    const [isBackOpenOpen, setIsBackOpenOpen] = React.useState(false);
    const [selectedServicesP, setSelectedServicesP] = React.useState(null);
    const [orderNumbersStrP, setOrderNumbersStrP] = React.useState("");
    const [AWBstrP, setAWBstrP] = React.useState("");
    const [selectedCarriersP, setSelectedCarriersP] = React.useState(null);
    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = React.useState(false);
    const [isFilterApplied, setIsFilterApplied] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(10); // number of rows
    const [nextPage, setNextPage] = React.useState(0);
    const [weightDiscrepancy, setWeightDiscrepancy] = React.useState([]);
    const [totalCount, setTotalCount] = React.useState(0);
    const weightDiscrepancyState = useSelector((state) => state.getWeightDiscrepancyDataReducer);
    const [filterOptions, setFilterOptions] = React.useState("");
    const location = useLocation();
    const { selectedRow } = location.state || {};
    // Search
    const [searchBy, setSearchBy] = React.useState("ORDER_NUMBER");
    const [loading, setLoading] = React.useState(false);
    const [searchShipmentList, setSearchShipmentList] = React.useState([]);
    const [selectedSearchShipment, setSelectedSearchShipment] = React.useState(null);
    const [inputValue, setInputValue] = React.useState("");
    const { tabStatus, orderId } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleChange = (newValue) => {
        navigate(`/weightdispute/${tabs[Number(newValue)]}`);
    };
    const handleFilterOpen = () => {
        setIsFilterDrawerOpen(true);
    };
    const handleFilterClose = () => {
        setIsFilterDrawerOpen(false);
    };
    const fetchWeightDiscrepancyData = (pageSize, pageNumber) => {
        const orderNumbersArray = orderNumbersStrP.trim() === "" ? null : orderNumbersStrP.split(",").map((item) => item.trim());
        const awbsArray = AWBstrP.trim() === "" ? null : AWBstrP.split(",").map((item) => item.trim());
        const carriersArray = !selectedCarriersP || selectedCarriersP.trim() === ""
            ? null
            : selectedCarriersP.split(",").map((item) => item.trim());
        const payload = {
            pageSize: pageSize,
            pageNumber: pageNumber ? pageNumber : 0,
            isAscending: false,
            sortType: "createdAt",
            startTimestamp: null,
            endTimestamp: null,
            statuses: [
                "in_review",
                "accepted_by_seller",
                "auto_accepted_by_seller",
                "accepted_by_carrier",
                "rejected_by_carrier",
            ],
            orderIds: orderId ? [orderId] : selectedRow === null || selectedRow === void 0 ? void 0 : selectedRow.orderIds,
            orderNumbers: orderNumbersArray,
            awbs: awbsArray,
            carriers: carriersArray,
        };
        setIsBackOpenOpen(true);
        dispatch(getWeightDiscrepancyDataRequest(payload));
    };
    React.useEffect(() => {
        var _a, _b;
        if (weightDiscrepancyState && weightDiscrepancyState.data && !weightDiscrepancyState.loading) {
            setIsBackOpenOpen(false);
            setTotalCount(((_a = weightDiscrepancyState.data) === null || _a === void 0 ? void 0 : _a.totalRecords) || 0);
            setWeightDiscrepancy(((_b = weightDiscrepancyState.data) === null || _b === void 0 ? void 0 : _b.weightMismatchRecords) || []);
        }
        else if (weightDiscrepancyState.error) {
            setIsBackOpenOpen(false);
            if (weightDiscrepancyState.error instanceof Error) {
                enqueueSnackbar(weightDiscrepancyState.error.message, {
                    variant: "error",
                });
            }
        }
    }, [weightDiscrepancyState]);
    React.useEffect(() => {
        if (selectedRow.orderIds && selectedRow.overallStatus) {
            const value = tabs.findIndex((x) => x === tabStatus) + 1;
            setActiveTab(selectedRow.overallStatus);
            setWeightDiscrepancy([]);
            setIsBackOpenOpen(true);
            dispatch(getWeightDiscrepancyDataReset());
            fetchWeightDiscrepancyData(rowsPerPage, 0);
        }
    }, [orderNumbersStrP, AWBstrP, selectedCarriersP, selectedServicesP, filterOptions, selectedRow]);
    const fetchSearchSuggestions = (searchTerm) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        setLoading(true);
        try {
            const response = yield APIIN.post(`/report/admin/weight/dispute/records`, {
                pageSize: 1,
                pageNumber: 0,
                isAscending: false,
                sortType: "createdAt",
                startTimestamp: null,
                endTimestamp: null,
                statuses: null,
                orderIds: searchBy === "ORDER_ID" ? [searchTerm] : null,
                orderNumbers: searchBy === "ORDER_NUMBER" ? [searchTerm] : null,
                awbs: searchBy === "TRACKING_CODE" ? [searchTerm] : null,
                carriers: null,
            });
            if (!_.isEmpty(response)) {
                let suggestions = (response === null || response === void 0 ? void 0 : response.weightMismatchRecords) &&
                    ((_a = response.weightMismatchRecords) === null || _a === void 0 ? void 0 : _a.map((item) => {
                        return {
                            orderId: item === null || item === void 0 ? void 0 : item.orderId,
                            orderNumber: item === null || item === void 0 ? void 0 : item.orderNumber,
                            status: (item === null || item === void 0 ? void 0 : item.processingStatus) === "in_review" ? "open" : "closed",
                        };
                    }));
                setSearchShipmentList(suggestions);
            }
        }
        catch (error) {
            console.error("Error fetching shipment", error);
        }
        finally {
            setLoading(false);
        }
    });
    const debouncedSearchSuggestions = _.debounce(fetchSearchSuggestions, 500);
    const handleInputChange = (value) => {
        if (value.length > 3) {
            debouncedSearchSuggestions(value);
        }
    };
    const handleSearchShipmentChange = (value, status) => {
        navigate(`/weightdispute/${value.orderId}`);
        window.location.reload();
    };
    return (React.createElement(Grid, { container: true, direction: "row", padding: 2, className: "m_background_color" },
        React.createElement(BackDropComponent, { open: isBackOpenOpen }),
        React.createElement(Grid, { item: true, paddingBottom: 3, xs: 12 },
            React.createElement(Grid, { className: "m_background_color", style: { marginBottom: "20px", width: "100%" } },
                React.createElement(Grid, { container: true, alignItems: "center", spacing: 1 },
                    React.createElement(Grid, { item: true },
                        React.createElement(IconButton, { onClick: () => navigate(-1) },
                            React.createElement(ArrowBackIcon, null))),
                    React.createElement(Grid, { item: true },
                        React.createElement(Typography, { sx: {
                                fontFamily: "Poppins",
                                fontSize: "20px",
                                fontWeight: 600,
                                color: "#121114",
                            } }, "Disputed discrepancies"))),
                React.createElement(Grid, { className: "m_border_grey m_bg_wt", sx: { p: 1, mt: 1, ml: 0.2, mb: -1 }, item: true, xs: 12, container: true, direction: "row", alignItems: "center", justifyContent: "space-between", padding: 1, spacing: 1 },
                    React.createElement(Grid, { item: true, container: true, direction: "row", xs: 8 },
                        React.createElement(Grid, { item: true, xs: 3 },
                            React.createElement(Select, { sx: { borderRadius: "8px 0 0 8px", borderRight: "0", backgroundColor: "#F5F8F8" }, fullWidth: true, id: "filterOption", size: "small", value: searchBy, onChange: (e) => setSearchBy(e.target.value) }, FILTER_ORDER_BY_OPTIONS_WEIGHT.map((item) => (React.createElement(MenuItem, { value: item.value },
                                React.createElement(Grid, { container: true, direction: "row", alignItems: "center", gap: 1 },
                                    React.createElement("img", { src: require(`../../../assets/searchOptionIcons/${item.value}.svg`).default }),
                                    React.createElement(Typography, { variant: "body1", className: "m_font_size_14" }, item.name))))))),
                        React.createElement(Grid, { item: true, xs: 9 },
                            React.createElement(Autocomplete, { disablePortal: true, loading: loading, options: searchShipmentList, getOptionLabel: (option) => {
                                    return `${option.orderNumber} / ${option.status} / ${option.orderId} / ${(option === null || option === void 0 ? void 0 : option.trackingCode) || ""} / ${option === null || option === void 0 ? void 0 : option.receiverPhoneNumber} / ${option === null || option === void 0 ? void 0 : option.receiverEmailAddress}`;
                                }, noOptionsText: "No record found", value: selectedSearchShipment, inputValue: inputValue, size: "small", loadingText: React.createElement("span", { className: "loader" }), renderInput: (params) => (React.createElement(TextField, Object.assign({}, params, { sx: {
                                        "& .MuiInputBase-root": {
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                        },
                                    }, placeholder: "Search by Order number/Order ID/ AWB" }))), renderOption: (props, option) => (React.createElement("li", Object.assign({}, props, { key: option.orderId, style: { display: "flex", justifyContent: "space-between", alignItems: "center" } }),
                                    React.createElement("div", { style: { flexGrow: 1 } },
                                        React.createElement(Typography, { variant: "subtitle1", fontWeight: 500 }, option.orderNumber),
                                        React.createElement(Typography, { className: "m_form_label_font", variant: "body1" },
                                            React.createElement("span", { style: { fontWeight: 500 } }, "Order ID"),
                                            ": ",
                                            option.orderId)),
                                    React.createElement("div", { style: { textAlign: "right" } },
                                        React.createElement(Chip, { label: option === null || option === void 0 ? void 0 : option.status, variant: "outlined", size: "small", className: "tr_chip m_font_size_12" }),
                                        React.createElement(Typography, { className: "m_form_label_font", variant: "body1" }, option.createdAt ? getDateString(+option.createdAt, "DD-MM-YYYY HH:mm") : "-")))), onInputChange: (event, newInputValue) => {
                                    setInputValue(newInputValue);
                                    handleInputChange(newInputValue);
                                }, onChange: (event, value) => {
                                    if ((value === null || value === void 0 ? void 0 : value.status) === "created" || (value === null || value === void 0 ? void 0 : value.status) === "new") {
                                        handleSearchShipmentChange(value, "New");
                                    }
                                    else {
                                        handleSearchShipmentChange(value, value === null || value === void 0 ? void 0 : value.status);
                                    }
                                    setInputValue("");
                                } }))),
                    React.createElement(Grid, { item: true, xs: 4 },
                        React.createElement(Grid, { container: true, justifyContent: "flex-end", spacing: 2 },
                            React.createElement(Grid, { item: true },
                                React.createElement(Button, { variant: isFilterApplied ? "contained" : "outlined", className: "or_group_button_height", size: "small", startIcon: React.createElement(FilterAltIcon, null), sx: isFilterApplied
                                        ? { textTransform: "none" }
                                        : { textTransform: "none", color: "black", border: "1px solid black" }, onClick: handleFilterOpen }, "Filters"),
                                activeTab === "2" && (React.createElement(Select, { value: filterOptions, displayEmpty: true, size: "small", sx: {
                                        marginLeft: 2,
                                        mt: 2,
                                        fontSize: "0.875rem",
                                        borderRadius: "4px",
                                        height: "36px",
                                        "& .MuiSelect-select": {
                                            paddingTop: "6px",
                                            paddingBottom: "6px",
                                            minHeight: "unset",
                                        },
                                    }, onChange: (event) => {
                                        const selectedAction = event.target.value;
                                        setFilterOptions(selectedAction);
                                    } },
                                    React.createElement(MenuItem, { value: "", disabled: true }, "All Status"),
                                    CLOSED_WEIGHT_OPTION_TYPE.map((option) => (React.createElement(MenuItem, { key: option.value, value: option.value },
                                        React.createElement(Typography, { variant: "body1", className: "m_font_size_14" }, option.name)))))))))),
                React.createElement(Box, { mt: 1 },
                    activeTab === "open" && (React.createElement(OpenDisputeComponent, { selectedCarriersP: selectedCarriersP, setSelectedCarriersP: setSelectedCarriersP, selectedServicesP: selectedServicesP, setSelectedServicesP: setSelectedServicesP, orderNumbersStrP: orderNumbersStrP, setOrderNumbersStrP: setOrderNumbersStrP, AWBstrP: AWBstrP, setAWBstrP: setAWBstrP, handleFilterOpen: handleFilterOpen, handleFilterClose: handleFilterClose, fetchWeightDiscrepancyData: fetchWeightDiscrepancyData, rowsPerPage: rowsPerPage, setRowsPerPage: setRowsPerPage, weightDiscrepancy: weightDiscrepancy, setWeightDiscrepancy: setWeightDiscrepancy, totalCount: totalCount, setTotalCount: setTotalCount, tabStatus: tabStatus, isFilterApplied: isFilterApplied, setIsFilterApplied: setIsFilterApplied, selectedRow: selectedRow })),
                    activeTab === "closed" && (React.createElement(ClosedDisputesComponent, { selectedCarriersP: selectedCarriersP, setSelectedCarriersP: setSelectedCarriersP, selectedServicesP: selectedServicesP, setSelectedServicesP: setSelectedServicesP, orderNumbersStrP: orderNumbersStrP, setOrderNumbersStrP: setOrderNumbersStrP, AWBstrP: AWBstrP, setAWBstrP: setAWBstrP, handleFilterOpen: handleFilterOpen, handleFilterClose: handleFilterClose, fetchWeightDiscrepancyData: fetchWeightDiscrepancyData, rowsPerPage: rowsPerPage, setRowsPerPage: setRowsPerPage, weightDiscrepancy: weightDiscrepancy, setWeightDiscrepancy: setWeightDiscrepancy, totalCount: totalCount, setTotalCount: setTotalCount, tabStatus: tabStatus, isFilterApplied: isFilterApplied, setIsFilterApplied: setIsFilterApplied, filterOptions: filterOptions, setFilterOptions: setFilterOptions }))))),
        isFilterDrawerOpen && (React.createElement(DisputeFilterDrawer, { orderNumbersStrP: orderNumbersStrP, AWBstrP: AWBstrP, isFilterDrawerOpen: isFilterDrawerOpen, handleFilterClose: handleFilterClose, setOrderNumbersStrP: setOrderNumbersStrP, setAWBstrP: setAWBstrP, selectedCarriersP: selectedCarriersP, selectedServicesP: selectedServicesP, setSelectedCarriersP: setSelectedCarriersP, setSelectedServicesP: setSelectedServicesP }))));
};
export default DisputeDiscripancyData;
